import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "917767904555"; // +91 77679 04555
const PREFILL = "Hi Nisha, I'd love to know more about Pause.";
const HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

const WhatsAppIcon = ({ className = "h-7 w-7" }) => (
  <svg
    viewBox="0 0 32 32"
    aria-hidden="true"
    className={className}
    fill="currentColor"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.516 2.478-1.318.128-.302.128-.56.093-.888-.043-.516-.043-.688-.287-.888-.573-.487-1.375-.615-1.677-.717zM16.11 27.462c-2.192 0-4.3-.615-6.146-1.762L5.94 27l1.32-3.9c-1.29-1.925-1.977-4.17-1.977-6.503 0-6.61 5.375-11.985 12-11.985 6.626 0 12 5.375 12 12 0 6.628-5.374 12.002-12 12.002zm10.35-22.352C23.673 2.324 20.005 0 16 0 7.72 0 0 6.42 0 14.7c0 2.647.688 5.24 2.006 7.526L0 32l9.978-3.267a15.983 15.983 0 0 0 6.132 1.203h.005C24.29 29.937 32 22.998 32 14.717c0-4.005-1.63-7.777-4.54-10.607z" />
  </svg>
);

export const WhatsAppFloat = () => {
  return (
    <motion.a
      data-testid="whatsapp-float"
      href={HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Nisha on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] flex items-center gap-3"
    >
      <span className="hidden md:inline-flex items-center gap-2 bg-[#1A1A1A] text-[#FAF7F2] font-body text-xs uppercase tracking-[0.14em] px-4 py-2 rounded-full opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-[0_10px_30px_rgba(26,26,26,0.18)]">
        Chat on WhatsApp
      </span>
      <span className="relative flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_36px_rgba(37,211,102,0.45)] transition-transform duration-300 group-hover:scale-[1.06]">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" style={{ animationDuration: "2.4s" }} />
        <WhatsAppIcon className="relative h-7 w-7 md:h-8 md:w-8" />
      </span>
    </motion.a>
  );
};
